//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'AssetLogList',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      pagePath: '/ea/asset/log',
      pageTitle: '资产日志',
      isorter: {
        column: 'log_time',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '资产编号',
        align: 'center'
      }, {
        dataIndex: 'productName',
        colName: 'product_name',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'sn',
        colName: 'sn',
        title: '出厂编号',
        align: 'center'
      }, {
        dataIndex: 'purchaseDate',
        colName: 'purchase_date',
        title: '购置日期',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '事件类型',
        align: 'center'
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: 'center'
      }, {
        dataIndex: 'createBy_userName',
        colName: 'create_by',
        title: '操作人',
        align: 'center'
      }, {
        dataIndex: 'logTime',
        colName: 'log_time',
        title: '事件时间',
        align: 'center',
        sorter: true
      }]
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    onDateLogTime: function onDateLogTime(value, dateArray) {
      this.queryParam.logTimeStart = dateArray[0];
      this.queryParam.logTimeEnd = dateArray[1];
    }
  }
};